import axios from 'axios';
import { useCallback } from 'react';
import * as Yup from 'yup';

import { SignupFormValues } from 'types/dashboard.d';

import { numericRegex } from 'packages/common-frontend/constants';

interface SignupResponse {
  // TODO: implement when ther's new signup flow
}

// interface SignupErrorResponse {
//   message: string;
// }

export const useSignupFormManagement = () => {
  const handleSubmit = useCallback(async (formValues: SignupFormValues) => {
    try {
      const { data } = await axios.post<SignupResponse>('/signup', formValues, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      // eslint-disable-next-line no-console
      console.log(data);
    } catch (err: any) {
      // TODO: please log proper error here when signup is implemented
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }, []);

  const formValidation = Yup.object().shape({
    email: Yup.string()
      .lowercase()
      .email('Must be a valid email')
      .required('Required'),
    password: Yup.string()
      .matches(numericRegex, 'one number required')
      .min(8, 'Minimum 8 characters required')
      .required('Required'),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref('password')], 'Password must be the same')
      .required('Required'),
  });

  const initialValues: SignupFormValues = {
    email: '',
    userType: 'BORROWER',
    password: '',
    passwordConfirmation: '',
  };

  return {
    handleSubmit,
    initialValues,
    formValidation,
  };
};
